import React, {ReactElement} from 'react';
import SadIcon from '../../../assets/images/sad.svg';
import HappyIcon from '../../../assets/images/happy.svg';

type RateUsProps = {
  onGreenClick: () => void;
  onRedClick: () => void;
};
const RateUs: React.FC<RateUsProps> = ({
  onGreenClick,
  onRedClick,
}: RateUsProps): ReactElement => {
  return (
    <div className="px-4 py-4">
      <div className="font-roboto text-big font-light">Rate us</div>
      <div className="font-roboto text-black text-opacity-50">
        How was your experience of using the MAX Buddy?
      </div>
      <div className="mt-6 flex justify-center">
        <div className="mr-6" onClick={onGreenClick}>
          <img className=" h-20 w-20 " src={HappyIcon} />
        </div>
        <div onClick={onRedClick}>
          {' '}
          <img className=" h-20 w-20 " src={SadIcon} />
        </div>
      </div>
    </div>
  );
};
export default RateUs;
